const availableEthnicities = [
    {
        ethnicity: 'Branca',
        code: 'white'
    },
    {
        ethnicity: 'Negra',
        code: 'black'
    },
    {
        ethnicity: 'Asiática',
        code: 'asian'
    },
    {
        ethnicity: 'Outras',
        code: 'others'
    }
]

export default availableEthnicities
